module.exports = __webpack_public_path__ + "assets/img/Super-Obvious-Landing-Page-w540.2ab380ee.jpg";